import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Subheader from '../../sharedComponent/Subheader';
import MediImg from "../../assets/images/biry.jpg";
import plusIco from "../../assets/images/plusIcon.svg";
import minusIco from "../../assets/images/minusIcon.svg";
import failedStatus from "../../assets/images/failedStatus.svg";
import SideArrow from "../../assets/images/accordianArrow.svg";
import coupon from "../../assets/images/coupon.svg";
import Modal from 'react-bootstrap/Modal';
import GreenAxe from "../../assets/images/greenCrossAxe.svg";
import Bell from "../../assets/images/hurrayBell.svg";
import { GetWithAuth, PostCallWithErrorResponse, PostCallWithErrorResponseReqBody, postWithAuthCallWithErrorResponse, simpleGetCallWithErrorResponse } from '../../api/ApiServices';
import ApiConfig from '../../api/ApiConfig';
import { AppContext } from '../../context/AppContext';
import { notifyError, notifySuccess } from '../../sharedComponent/notify';
import { Spinner } from 'react-bootstrap';
import AppDownloadPromptWrapper from '../../sharedComponent/AppDownloadPrompt/AppDownloadPromptWrapper';

const PetCart = () => {

    const [couponModal, setCouponModal] = useState(false);
    const [bell, setBell] = useState(false);
  const [cartData, setCartData] = useState([]);
  const [countCart, setCountCart] = useState(0);
const [orderOption, setOrderOption] = useState("");
const [showPrompt, setShowPrompt] = useState(false)
const [toCheckoutLoading, setToCheckoutLoading] = useState(false);

  
  const [total, setTotal] = useState(0);
  const [refresh, setRefresh] = useState(false);
   const [isLoading, setIsLoading] = useState(false);
  const {
setStoresList,
selectedStore, setRestaurant, restaurant_status,subscribeToEvent,defaultImgs

  } = useContext(AppContext);




 const delay = 1500 + Math.random() * 1000; // 1.5s–2.5s
 
  useEffect(() => {
     if (!selectedStore) return;
   let timeoutId;
     const eventName = `${selectedStore}/updated-menu`;
 
     const unsubscribe = subscribeToEvent(eventName, (data) => {
       console.log("Menu updated:", data);
 
       // 🔥 Call your APIs
     timeoutId = setTimeout(() => {
  loadCart()
 }, delay);
     });
 
     return () => {
       if (timeoutId) {
       clearTimeout(timeoutId);
     }
       unsubscribe();
     };
   }, [subscribeToEvent, selectedStore]);
  
const navigate = useNavigate();
 const handleOptionChange = (method) => {
    setOrderOption(method);
  };

  // ✅ Load Cart Items
  const loadCart = async () => {
    try {
      let res = await simpleGetCallWithErrorResponse(`${ApiConfig?.CART_LIST}`);
    

      if (res?.json.success) {
              let valM = 0;
        res?.json.data?.map((i) => {
          let val = 0;
          val += parseFloat(i?.item_price);
          // console.log("val==>",i)
          if (i?.variation?.variation_price) {
            val += parseFloat(i?.variation?.variation_price);
          }
          val = val * parseFloat(i?.order_quantity);
          i?.addon?.map((ai) => {
            val += parseFloat(ai?.addon_price);
          });
          // let f=i?.variations?.[0]?.variation_price
          // console.log("fdsfsdaf",f)
          // val=val+(parseFloat(i?.item_price)*parseFloat(i.order_quantity))+(f??0)

          // i?.variations
          valM += val;
        });
    
        setTotal(valM);
        setCartData(res?.json.data);
        let valc = 0;
        res?.json?.data?.map((i) => {
          valc += i.order_quantity;
        });
        setCountCart(valc);
      }
    } catch (error) {
      console.error("Cart Load Error:", error);
      setTotal(0);
      setCartData([]);
    }
  };

  useEffect(() => {
    loadCart();
  }, [selectedStore]);

  // ✅ Change Quantity API Call
  const changeQuantity = async (item) => {

    return new Promise (async (resolve , reject) => {

    
    try {
      console.log("Updating item =>>", item);

      let addons = [];
      item?.addon?.map((i) => {
        addons.push({
          cart_addon_id: i?.addon_cart_id,
          quantity: 1,
          addon_id: i?.addon_id,
        });
      });

      let requestBody = {
        cart_id: item?.cart_id,
        order_quantity: item?.order_quantity,
        addons: addons,
      };


      let res = await PostCallWithErrorResponse(`${ApiConfig?.UPDATE_CART}`,  JSON.stringify(requestBody));
      console.log("UpdateCart Res =>>", res);

      if (res?.json.success) {
        // AlertDialogSuccess(res?.message);
        setRefresh(!refresh);
         loadCart();
         resolve(true);
      } 
      else {
        notifyError(res?.json?.message)
        resolve(false);
      }
    } catch (error) {
     notifyError('Something went wrong.')
     resolve(false);
    }
    })
  };

  // ✅ Increase Quantity (and call API)
  const handleIncrease = (index) => {

       const updated = [...cartData];
          updated[index].order_quantity += 1;
    changeQuantity(updated[index])
  .then((success) => {
    if (success) {
    
  
    
    setCartData(updated);
   
    } else {
         updated[index].order_quantity -= 1;
     
    }
  })
  .catch((error) => {
    console.log("Error:", error);
  });
   
  };


    const deleteCartItem = async (item) => {
      try {
        let requestBody = {
          cart_id: item?.cart_id,
        };
        console.log("remove", requestBody);
  
        let res = await postWithAuthCallWithErrorResponse(
          `${ApiConfig?.REMOVE_CART_ITEM}`,
          JSON.stringify(requestBody)
        );
        console.log("res", res);
        if (res?.success || res?.json?.success) {
          let fil = cartData?.filter((i) => i?.cart_id != item?.cart_id);
          setCartData(fil);
          notifySuccess(res?.message || res?.json?.message);
          setRefresh(!refresh);
          loadCart();
        }
      } catch (error) {
        notifyError(error?.message);
      }
    };

  // ✅ Decrease Quantity (and call API)
  const handleDecrease = (index , item) => {

    if (item?.order_quantity == 1) {
      deleteCartItem(item);
      return
    }
    const updated = [...cartData];
    if (updated[index].order_quantity > 1) {
      updated[index].order_quantity -= 1;
      setCartData(updated);
      changeQuantity(updated[index]);
    }
  };

  // ✅ Calculate total price for each item
  const getItemTotal = (item) => {
    let price = parseFloat(item?.item_price || 0);
    let variationPrice = parseFloat(item?.variation?.variation_price || 0);
    let base = (price + variationPrice) * parseFloat(item?.order_quantity || 1);
    let addonTotal =
      item?.addon?.reduce(
        (sum, ai) => sum + parseFloat(ai?.addon_price || 0),
        0
      ) || 0;
    return base + addonTotal;
  };



   const getRestaurant = async () => {
       console.log('tttttttttt')
    // handleLogout()
    // return
    setToCheckoutLoading(true);
    try {
      let res = await GetWithAuth(
        `${ApiConfig?.GET_RESTAURANT}/${selectedStore}`
      );
      console.log("ressstau", JSON?.stringify(res));
      if (res?.success) {
         console.log('vvvvvvvvvvvv')
        if (res?.data?.store_status == "0") {
          setRestaurant( false );
          // alert("Online service is not currently available");
          notifyError("Online service is not currently available");
          return;
        } else {
       setRestaurant(true );
        navigate("/Checkout", { state: { orderOption } });
          // handlePayment();
        }
      } else {
        console.log('rrrrrrrrrrrrrrrrrr')
        notifyError(res?.json.message)
      }
    } catch (error) {
      console.log('api error--', error)
      notifyError(error.message)
      // handleLogout();
    } finally {
      setToCheckoutLoading(false);
    }
  };
      console.log('restaurant_status--', restaurant_status)










      
  const proceedToCheckoutButtonFunction = () => {
    console.log('restaurant_status--', restaurant_status)
      let check = cartData?.some((i) => i?.item_active == 0|| i?.quantity == 0 || i?.in_stock == 0 || (i?.variations?.length>0 && !i?.variations?.some(i=>i?.quantity>0)) );
    if (check) {
     notifyError(
        "One or more item is out of stock please remove item from cart to continue"
      );
      return;
    }
      //  if (restaurant_status == false ) {
      //           notifyError("Online service is not currently available");
      //           return;
      //         }
              if (cartData?.length < 1) {
                notifyError(
                  "Please add some product in cart then try again"
                  
                );

                return;
              }
              if (!isLoading) {
            
                getRestaurant();
              }
  }
    return (
        <>
            <div className="medicineCart" id="cx-main">
                <Subheader />
                {/*Content Cards */}
                <div className="mainCartBox">
                    <div className="row">
                        <div className="col-md-8">
                            <div className="cartTable">
                                <div className="scroller">
                                    <table className="table">
        <thead className="tHead">
          <tr>
            <th>Product Name</th>
            <th>Quantity</th>
            <th>Price</th>
            <th>Amount</th>
          </tr>
        </thead>

        <tbody className="tBody">
    
          {cartData?.length > 0 ? (
            cartData.map((item, index) => (
              <tr key={index} className={` `}>
                <td>
                  <div className={`imgFlex position-relative ${item?.item_active == 0  || item?.in_stock == 0 ||(item?.in_stock==1 && item?.quantity==0)||(item?.item_allow_variation===1 && item?.in_stock==1 && item?.variations?.length==0) ?  'greyscale' : ''}`}>
                    <img
                      src={item?.item_image_url || ( defaultImgs?.item_image || MediImg)}
                      className="MediImg"
                      alt=""
                    />
                     {item?.item_active == 0  || item?.in_stock == 0 ||(item?.in_stock==1 && item?.quantity==0)||(item?.item_allow_variation===1 && item?.in_stock==1 && item?.variations?.length==0) ?  (
          <div className="out-of-stock-overlay" style={{width:'90%'}}>
            <span className="out-of-stock-text">Out of Stock</span>
          </div>
        ) : null}
                    <label htmlFor="" className="Prdctname">
                      {item?.item_name}
                    </label>
                  </div>
                </td>
                 

                <td>
                  <div className="qntyBox">
                    <label onClick={() => handleDecrease(index, item)}>
                      <img src={minusIco} alt="-" />
                    </label>
                    <label htmlFor="" className="value">
                      {item?.order_quantity}
                    </label>
                    <label onClick={() => handleIncrease(index)}>
                      <img src={plusIco} alt="+" />
                    </label>
                  </div>
                </td>

                {/* <td>
                  <label className="rateTag">
                    ₹{" "}
                    {(
                      parseFloat(item?.item_price || 0) +
                      parseFloat(item?.variation?.variation_price || 0)
                    ).toFixed(2)}
                  </label>
                </td> */}

                <td>
  {item?.addon && item.addon.length > 0 ? (
    <div>
      {item.addon.map((addon, index) => (
        <div key={index} className="rateTag">
          {addon.addon_name} : ₹{parseFloat(addon.addon_price).toFixed(2)}
        </div>
      ))}

      <div className="rateTag">
        price : ₹
        {(
          parseFloat(item?.item_price || 0) +
          parseFloat(item?.variation?.variation_price || 0)
        ).toFixed(2)}
      </div>
    </div>
  ) : (
    <label className="rateTag">
      ₹
      {(
        parseFloat(item?.item_price || 0) +
        parseFloat(item?.variation?.variation_price || 0)
      ).toFixed(2)}
    </label>
  )}
</td>


                <td>
                  <label className="rateTag">
                    ₹ {getItemTotal(item).toFixed(2)}
                  </label>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" style={{ textAlign: "center", color: "gray" }}>
                No items in cart
              </td>
            </tr>
          )}
        </tbody>
      </table>

     
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="couponCard">
                                {/* <div className="headingFlex">
                                    <h1>Best Coupons For you</h1>
                                    <label htmlFor="">All Coupons <img src={SideArrow} alt="" /></label>
                                </div> */}
                                {/* <div className="applyCouponBox">
                                    <h1><img src={coupon} alt="" />Apply Coupons</h1>
                                    {
                                        couponModal ? <span className='text-danger'>Remove</span> : <button className='applyBtn'
                                            onClick={() => setCouponModal(true)}>Apply</button>
                                    }

                                </div> */}
                                <div className="cartSummaryBox">
                                    <div className="headingFlex">
                                        <h1>Cart Summary</h1>
                                        <label htmlFor="">{`( ${countCart} Items )`}</label>
                                    </div>
                                    <div className="contentFlex">
                                        <div className="keyValueFlex">
                                            <label htmlFor="" className='key'>Total Price</label>
                                            <label htmlFor="" className='value'>₹ {' '}{total}</label>
                                        </div>
                                        {/* <div className="keyValueFlex">
                                            <label htmlFor="" className='key'>Shipping</label>
                                            <label htmlFor="" className='value'>₹ 20:00</label>
                                        </div>
                                        <div className="keyValueFlex">
                                            <label htmlFor="" className='key'>Tax</label>
                                            <label htmlFor="" className='value'>₹ 0:00</label>
                                        </div> */}
                                    </div>
                                    {/* <div className="bottomCard">
                                        <label htmlFor="" className='Total'>Total</label>
                                        <label htmlFor="" className='TotalAmnt'>₹ {total}</label>
                                    </div> */}
                                </div>


                                  <div className="cartSummaryBox">
                                    <div className="headingFlex">
                                        <h1>Choose Your Option</h1>
                                          </div>
                                    <div className="contentFlex">
                                      
 {/* <div className="keyValueFlex " style={{flexDirection:'column' , alignItems:'start'}}>
                                          <label className='key' style={{ display: "block", marginBottom: "4px" }}>
        Delivery
        <input
          type="checkbox"
          checked={orderOption === "delivery"}
          onChange={() => handleOptionChange("delivery")}
          style={{marginLeft:'4px'}}
        />
     
      </label>

      <label  className='key' style={{ display: "block", marginBottom: "4px" }}>
         Takeaway
        <input
          type="checkbox"
          checked={orderOption === "takeaway"}
          onChange={() => handleOptionChange("takeaway")
            
          }
          style={{marginLeft:'4px'}}
        />
     
      </label>
      </div> */}

 <div className="keyValueFlex optionList-custom" style={{flexDirection:'column' , alignItems:'start'}}>
        <div class="form-check">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="flexRadioDefault42"
                                  id="flexRadioDefault23"
                                  
                                   checked={orderOption === "delivery"}
                                   onChange={() => handleOptionChange("delivery")}
                                />
                                <label
                                  class="form-check-label"
                                  for="flexRadioDefault23"
                                >
                                  Delivery
                                </label>
                              </div>

                                <div class="form-check">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="flexRadioDefault42"
                                  id="flexRadioDefault24"
                                   checked={orderOption === "takeaway"}
                                  onChange={() => handleOptionChange("takeaway")}
                                />
                                <label
                                  class="form-check-label"
                                  for="flexRadioDefault24"
                                >
                                  Takeaway
                                </label>
                              </div>
                                  </div>    
                                    </div>
                                   
                                </div>
                            </div>
                            <div className="checkoutBtn">
                                {/* <Link to="/Checkout" state={{
                                  orderOption : orderOption
                                }}> */}
                                    <button disabled={!orderOption || toCheckoutLoading} onClick={() => {
              // if (restaurant_status == false ) {
              //   notifyError("Online service is not currently available");
              //   return;
              // }
              // if (cartData?.length < 1) {
              //   notifyError(
              //     "Please add some product in cart then try again"
                  
              //   );

              //   return;
              // }
              // if (!isLoading) {
            
              //   getRestaurant();
              // }
proceedToCheckoutButtonFunction()
              // setShowPrompt(true);
            }} className='checkBtn' >{toCheckoutLoading ? <Spinner size='sm' /> : 'Proceed To Checkout'}</button>
                                {/* </Link> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {/* APply coupon Modal */}
            {
                couponModal ? <>
                    <Modal
                        size='md'
                        show={coupon}
                        onHide={() => setCouponModal(false)}
                        centered
                    >
                        <Modal.Body id='couponModalBody'>
                            <div className="modalCouponBox">
                                <div className="headingFlex">
                                    <h1 className='modalName'>Apply Coupon</h1>
                                    <label htmlFor="" className='CrossImg'
                                        onClick={() => setCouponModal(false)}
                                    >
                                        <img src={GreenAxe}
                                            alt="" />
                                    </label>
                                </div>
                                <div className="couponBoxBorder">
                                    <label htmlFor="" className='animalPer'>ANIMAL20%</label>
                                    <label htmlFor="" className='Check'>Check</label>
                                </div>
                                <div className="checkAndDiscount">
                                    <div className="checkboxIn">
                                        <input class="form-check-input" type="checkbox" value="" checked id="flexCheckDefault" />
                                    </div>
                                    <div className="discountBadge">
                                        <label className='innBadge' htmlFor='flexCheckDefault'>ANIMAL20%</label>
                                        <p className='paraPara'>Expires on : 31st December 2023 , 11:59 PM</p>
                                    </div>
                                    <div className="savingDetails">
                                        <p className='savePara'>Save ₹200</p>
                                        <p className='belowPaara'>₹200 off on minimum purchase of ₹2000.</p>
                                    </div>
                                </div>
                                <div className="checkAndDiscount">
                                    <div className="checkboxIn">
                                        <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                    </div>
                                    <div className="discountBadge">
                                        <label className='innBadge' htmlFor='flexCheckDefault'>ANIMAL20%</label>
                                        <p className='paraPara'>Expires on : 31st December 2023 , 11:59 PM</p>
                                    </div>
                                    <div className="savingDetails">
                                        <p className='savePara'>Save ₹200</p>
                                        <p className='belowPaara'>₹200 off on minimum purchase of ₹2000.</p>
                                    </div>
                                </div>
                                <div className="checkAndDiscount">
                                    <div className="checkboxIn">
                                        <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                    </div>
                                    <div className="discountBadge">
                                        <label className='innBadge' htmlFor='flexCheckDefault'>ANIMAL20%</label>
                                        <p className='paraPara'>Expires on : 31st December 2023 , 11:59 PM</p>
                                    </div>
                                    <div className="savingDetails">
                                        <p className='savePara'>Save ₹200</p>
                                        <p className='belowPaara'>₹200 off on minimum purchase of ₹2000.</p>
                                    </div>
                                </div>
                                <div className="belowBottom">
                                    <div className="savingsTxt">
                                        <p>Maximum Savings</p>
                                        <label htmlFor="">₹200 </label>
                                    </div>
                                    <div className="applyBox">
                                        <button className='applyBtn' onClick={() => {
                                            setBell(true)
                                            setCouponModal(false)
                                        }}>Apply</button>
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>
                </> : null
            }
            {/* Bell Modal */}
            {
                bell ?
                    <>
                        <Modal
                            size='sm'
                            show={bell}
                            onHide={() => setBell(false)}
                            centered
                        >
                            <Modal.Body >
                                <div className="bellBox">
                                    <img src={Bell} alt="" />
                                    <p>Coupon Applied Successfully !</p>
                                </div>
                            </Modal.Body>
                        </Modal>
                    </>
                    :
                    null
            }
             {/* <AppDownloadPromptWrapper showPrompt={showPrompt}
              setShowPrompt={setShowPrompt}
              proceedToCheckoutButtonFunction={proceedToCheckoutButtonFunction}
              /> */}
        </>
    )
}

export default PetCart;
